export const uniq = <T>(arr: T[]) => [...new Set(arr)];

export function isTruthy<T>(value?: T | undefined | null | false): value is T {
  return !!value;
}

export const notEmpty = <T>(
  value: T | false | undefined | null | '' | 0
): value is T => !!value;
